import React, { createContext, useContext, useMemo } from 'react';
import { useAccounts } from '@jupiterone/jupiter-web-toolkit/src/api/fetch/useAccounts';
import { AbacRuleName } from '@jupiterone/jupiter-types';
import { enforceAny } from '@lifeomic/abac';

const DEFAULT_POLICY = { rules: {} };

export const useABACLogic = () => {
  const { account } = useAccounts();
  const policy = useMemo(() => account?.policy || DEFAULT_POLICY, [account]);

  const enforce = (operations: AbacRuleName[]): boolean => {
    if (!policy) return false;
    const rules = new Set<AbacRuleName>(operations);
    rules.add('accessAdmin'); // Always grant admins
    return enforceAny([...rules], policy, {});
  };

  const isAdmin = useMemo(() => {
    return enforce([]);
  }, [policy]);

  return {
    policy,
    isAdmin,
    enforce,
  };
};

type UseABAC = ReturnType<typeof useABACLogic>;
const ABACContext = createContext({} as UseABAC);
export const useABAC = () => useContext(ABACContext);

interface UseABACContextProviderProps {
  children: React.ReactNode;
}

export const ABACProvider = ({ children }: UseABACContextProviderProps) => {
  const abac = useABACLogic();
  return <ABACContext.Provider value={abac}>{children}</ABACContext.Provider>;
};
